import { render } from "./UnNftMedia.vue?vue&type=template&id=c95aadf6"
import script from "./UnNftMedia.vue?vue&type=script&lang=js"
export * from "./UnNftMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__